import styled, { css } from "styled-components";
import { BRAND, TEXT_PRIMARY } from "@streeteasy/design-system/colors";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";

export const Link = styled(TextAction).attrs({
  underlined: false,
  element: actionElements.button,
  typography: textActionTypography.BODY
})`
  background: none;
  border: 0;
  color: ${TEXT_PRIMARY};
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  line-height: 48px;
  padding: 0;
  text-transform: uppercase;

  &[aria-expanded="true"] {
    border-bottom: 2px solid ${BRAND};
    color: ${BRAND};
    text-decoration: none;
  }

  &:hover,
  &:active,
  &:focus {
    color: ${BRAND};
    background: none;
    background-color: inherit;
    fill: ${BRAND};
  }
`;

export const ListItem = styled.li`
  display: inline-block;
  font-size: 14px;
  height: 50px;
  padding: 0 18px;

  &:hover {
    ${Link} {
      border-bottom: 2px solid ${BRAND};
      color: ${BRAND};
      text-decoration: none;
    }
  }

  ${({ isNew }) =>
    isNew
      ? css`
          &:after {
            background-color: #f1a728;
            border-radius: 50%;
            content: "";
            display: block;
            height: 6px;
            position: absolute;
            top: 14px;
            transform: translateX(-100%);
            width: 6px;
          }
        `
      : ""}
`;
